module.exports = __webpack_public_path__ + "static/media/ic-caret-down-white.00ea3f58.svg";